import { useContext } from "react";
import clsx from "clsx";
import { usePage, useSection } from "@tree-company/tree-query";
import { LocaleContext } from "../app";
import { Button } from "./button";
import { usePageEffects } from "../hooks/use_page_effects";

export function BoostPage({
  className,
  page,
  children,
  handleSave,
  onPreviousPage,
}) {
  const { translate } = useContext(LocaleContext);
  const { title, htmlAttributes, key } = usePage(page);
  const hasSelection = useBoostSelection(page);
  usePageEffects({ key });

  return (
    <form
      className={clsx(className, "page", "page--boost", htmlAttributes.class)}
      onSubmit={handleSave}
    >
      <div className="page__main">
        {title && (
          <div className="page-intro">
            <h1 className="page__title">{title}</h1>
            <p className="page__text">{translate("boost.body")}</p>
          </div>
        )}
        {children}
      </div>
      <div className="page__actions">
        <Button
          variation="clear"
          className="page__action page__action--previous"
          onClick={onPreviousPage}
          iconPrev
          srText
        >
          {translate("navigation.previous")}
        </Button>
        <Button
          type="submit"
          variation={hasSelection ? "filled" : "outlined"}
          className="page__action page__action--next"
          iconNext
        >
          {translate(hasSelection ? "navigation.next" : "navigation.skip")}
        </Button>
      </div>
    </form>
  );
}

function useBoostSelection(page) {
  const section = page.sections.find((s) => s.key === "boost-priorities");
  const { value } = useSection(section);
  return Array.isArray(value) && value.length > 0;
}
